import { api } from './client';

export type AccrualKind = 'MAIN' | 'ADVANCE' | 'VACATION' | 'SICK' | 'COMPENSATION' | 'CIVIL';

export interface AccrualRegistryItem {
  id: string;
  organization_id: string;
  kind: AccrualKind;
  document_number: string;
  document_date: string | null;
  period_year: number | null;
  period_month: number | null;
  employee_id: string | null;
  employee_name: string | null;
  gross: string;
  net: string;
  // Виплачено/борг цього виду за період (null для непроведеного).
  paid: string | null;
  debt: string | null;
  posted: boolean;
  external_source: string | null;
  route: 'payroll' | 'vacation' | 'sick' | 'compensation';
  calculation_id: string | null;
}

export interface EmployeeDebtItem {
  employee_id: string;
  employee_name: string;
  period_year: number;
  period_month: number;
  account_code: string;
  kind_label: string;
  amount: string;
}

const BASE = '/payroll-registry';

export const payrollRegistry = {
  accruals: (params: {
    organization_id?: string; kind?: string;
    period_year?: number; period_month?: number; period_from?: string; period_to?: string;
  }) => api.get<AccrualRegistryItem[]>(`${BASE}/accruals`, { params })
    .then((r) => r.data),
  // Серверна пагінація/сортування (ag-Grid Infinite, 2026-08-23).
  accrualsPage: (params: {
    organization_id?: string; kind?: string;
    period_year?: number; period_month?: number; period_from?: string; period_to?: string;
    sort_by?: string; sort_dir?: 'asc' | 'desc'; limit?: number; offset?: number;
  }) => api.get<{ items: AccrualRegistryItem[]; total: number; limit: number; offset: number }>(
    `${BASE}/accruals/page`, { params }).then((r) => r.data),
  employeeDebtsPage: (params: {
    organization_id: string; sort_by?: string; sort_dir?: 'asc' | 'desc'; limit?: number; offset?: number;
  }) => api.get<{ items: EmployeeDebtItem[]; total: number; limit: number; offset: number; total_amount: string }>(
    `${BASE}/employee-debts/page`, { params }).then((r) => r.data),
  employeeDebts: (organization_id: string) =>
    api.get<EmployeeDebtItem[]>(`${BASE}/employee-debts`, {
      params: { organization_id },
    }).then((r) => r.data),
};
